import React, { Fragment } from "react";
import PropTypes from "prop-types";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import paymentTermFields from "../paymentTermFields";
import FormGrid from "../../../../../../components/forms/FormGrid";
import ActionButtons from "../../../../../../components/forms/ActionButtons";
import FormikForm from "../../../../../../components/forms/FormikForm";
import propTypes from "../../../../../../constants/propTypes";

const PaymentTermForm = ({ onSubmit, initialValues, isUpdate, loading }) => {
  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={BWModels.loadSchema("PaymentTerm")}
    >
      {({ handleSubmit, values, errors, ...formikProps }) => (
        <Fragment>
          <FormGrid
            fields={paymentTermFields()}
            values={values}
            errors={errors}
            {...formikProps}
          />
          <ActionButtons
            onSend={handleSubmit}
            isModal={true}
            loading={loading}
            sendButtonText={isUpdate ? "Save" : "Add Term"}
          />
        </Fragment>
      )}
    </FormikForm>
  );
};

PaymentTermForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
  loading: PropTypes.bool,
  initialValues: propTypes.term,
};

export default PaymentTermForm;
